<script>
import LoadingIndicator from '@/Components/Utilities/LoadingIndicator'

export default {
    components: {
        LoadingIndicator
    },
    props: {
        buttonClasses: {
            type: String,
            default:
                'w-full rounded-full bg-spotler-honesty text-rss-blue-50 mt-5 p-2 uppercase transition ease-in-out duration-300 hover:shadow-md focus:outline-none focus:ring focus:ring-rss-blue-300 disabled:opacity-75'
        },
        buttonSubmitting: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            submitting: this.buttonSubmitting
        }
    },
    methods: {
        submit(e) {
            this.toggleLoading()
            e.target.form.submit()
        },
        toggleLoading(e) {
            this.submitting = !this.submitting
        }
    }
}
</script>

<template>
    <button
        :class="buttonClasses"
        type="submit"
        :disabled="submitting"
        @click="submit"
    >
        <slot v-if="!submitting">
            Submit
        </slot>
        <loading-indicator :loading="submitting" />
    </button>
</template>
